var _path, _path2, _path3, _path4, _path5, _path6;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgDocumentCheckmark(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M5.00065 2.5H15.0007C15.9211 2.5 16.6673 3.24619 16.6673 4.16667V15.8333C16.6673 16.7538 15.9211 17.5 15.0007 17.5H5.00065C4.08018 17.5 3.33398 16.7538 3.33398 15.8333V4.16667C3.33398 3.24619 4.08018 2.5 5.00065 2.5Z",
    stroke: "#4D5E93",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M6.66602 8.33366H13.3327",
    stroke: "#4D5E93",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M6.66602 10.8337H13.3327",
    stroke: "#4D5E93",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M9.16602 5.83366H6.66602",
    stroke: "#4D5E93",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M10.834 14.1667H13.334",
    stroke: "#4D5E93",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M6.66602 13.963L7.21917 14.46L8.33268 13.46",
    stroke: "#4D5E93",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDocumentCheckmark);
export default __webpack_public_path__ + "static/media/document-checkmark.952ab4b45e7d6b820e3b61e3757becc4.svg";
export { ForwardRef as ReactComponent };